import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
    mutations: {
      onError: (error) => {
        const message = error instanceof Error ? error.message : 'Something went wrong'
        console.error('[Mutation Error]', message)
      },
    },
  },
})
